import React, { type ComponentProps, useState } from "react";

import type { PolicyMetaData } from "@/core/types";
import { Button2 } from "@/ui2/atoms/Button";
import { Card2 } from "@/ui2/atoms/Card";
import { ConsentDisclaimer } from "@/components/Common/ConsentDisclaimer/ConsentDisclaimer";
import { Heading2 } from "@/ui2/atoms/Heading";

import { ConsentToTreatment } from "../ConsentToTreatment";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { getCurrentPolicyVersion } from "@/lib/helpers/getCurrentPolicyVersion";

const customDisclaimerPrefix = "By selecting “Agree & Continue”, you agree to aptihealth’s";

type ConsentProps = Omit<ComponentProps<typeof Card2>, "onSubmit"> & {
  onSubmit: (response?: boolean) => Promise<void>;
  policyMetadata: PolicyMetaData;
  subTitle: string;
  title: string;
};

export function ConsentOnLogIn({ onSubmit, policyMetadata, subTitle, title }: ConsentProps) {
  const [hasConsented, setHasConsented] = useState(false);
  const policyVersion = getCurrentPolicyVersion({ policyMetadata, policy: "CONSENT_TO_TREATMENT" });

  return (
    <Card2 className="tw:p-12 tw:flex-col tw:gap-8 tw:lg:max-w-148 tw:mx-auto">
      <Heading2 as="h1" size={4} className="tw:text-center">
        {title}
      </Heading2>

      <p className="body-md" {...getAutomationDataAttr("consent-on-log-in-subtitle")}>
        {subTitle}
      </p>

      <ConsentToTreatment
        consentEvent={() => setHasConsented((prevState) => !prevState)}
        version={policyVersion}
      />

      <Button2
        isDisabled={!hasConsented}
        className="tw:w-full"
        onPress={() => onSubmit(true)}
        {...getAutomationDataAttr("consent-on-log-in-agree-and-continue-button")}
      >
        Agree & Continue
      </Button2>

      <ConsentDisclaimer
        customDisclaimerPrefix={customDisclaimerPrefix}
        policyMetadata={policyMetadata}
      />
    </Card2>
  );
}
